<div class="sharepoint-navigator">
  <div class="sharepoint-navigator__header">
    <h3 class="sharepoint-navigator__title">Navegador de SharePoint</h3>
    <button class="sharepoint-navigator__close" (click)="cancel()" aria-label="Cerrar">
      <ion-icon name="close-outline"></ion-icon>
    </button>
  </div>

  <!-- Búsqueda de sites (solo en vista sites) -->
  <div *ngIf="viewStep === 'sites'" class="sharepoint-navigator__search">
    <input
      type="text"
      class="sharepoint-navigator__search-input"
      [(ngModel)]="searchQuery"
      (ngModelChange)="onSearchQueryChange($event)"
      (keyup.enter)="searchSites()"
      placeholder="Buscar sites por nombre..."
    />
    <button
      type="button"
      class="sharepoint-navigator__search-btn"
      (click)="searchSites()"
      aria-label="Buscar">
      <ion-icon name="search-outline"></ion-icon>
      {{'SHAREPOINT.SEARCH_LABEL' | translate}}
    </button>
  </div>

  <div class="sharepoint-navigator__breadcrumbs" *ngIf="viewStep !== 'preview'">
    <button
      *ngFor="let crumb of breadcrumbs; let i = index"
      class="sharepoint-navigator__breadcrumb"
      (click)="navigateToBreadcrumb(crumb)"
      [class.active]="i === breadcrumbs.length - 1">
      {{ crumb.label }}
    </button>
    <button
      *ngIf="viewStep === 'drives' || viewStep === 'files'"
      class="sharepoint-navigator__up"
      (click)="goUp()"
      aria-label="Subir nivel">
      <ion-icon name="arrow-up-outline"></ion-icon>
    </button>
  </div>

  <div class="sharepoint-navigator__content">
    <div *ngIf="loading" class="sharepoint-navigator__loading">
      <ion-spinner></ion-spinner>
      <p>{{'SHAREPOINT.LOADING_LABEL' | translate}}</p>
    </div>

    <!-- Vista Sites -->
    <ng-container *ngIf="viewStep === 'sites' && !loading">
      <div *ngIf="filteredSites.length === 0" class="sharepoint-navigator__empty">
        <ion-icon name="business-outline"></ion-icon>
        <p>{{ (isSearchMode ? 'SHAREPOINT.NO_SITES_CRITERIA' : 'SHAREPOINT.NO_SITES_AVAILABLE') | translate }}</p>
      </div>
      <div *ngIf="filteredSites.length > 0" class="sharepoint-navigator__list">
        <div
          *ngFor="let site of filteredSites"
          class="sharepoint-navigator__item folder"
          (click)="selectSite(site)">
          <div class="sharepoint-navigator__item-icon">
            <ion-icon name="business-outline"></ion-icon>
          </div>
          <div class="sharepoint-navigator__item-info">
            <span class="sharepoint-navigator__item-name">
              <ng-container *ngFor="let seg of getHighlightedNameSegments(site)">
                <span *ngIf="seg.match" class="sharepoint-navigator__highlight">{{ seg.text }}</span>
                <ng-container *ngIf="!seg.match">{{ seg.text }}</ng-container>
              </ng-container>
            </span>
            <span *ngIf="site.description" class="sharepoint-navigator__item-desc">{{ site.description }}</span>
          </div>
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </div>
      </div>
    </ng-container>

    <!-- Vista Drives -->
    <ng-container *ngIf="viewStep === 'drives' && !loading">
      <div *ngIf="drives.length === 0" class="sharepoint-navigator__empty">
        <ion-icon name="hardware-chip-outline"></ion-icon>
        <p>{{'SHAREPOINT.NO_DRIVES_FOR_SITE_ADVISE' | translate}}</p>
      </div>
      <div *ngIf="drives.length > 0" class="sharepoint-navigator__list">
        <div
          *ngFor="let drive of drives"
          class="sharepoint-navigator__item folder"
          (click)="selectDrive(drive)">
          <div class="sharepoint-navigator__item-icon">
            <ion-icon name="folder-outline"></ion-icon>
          </div>
          <div class="sharepoint-navigator__item-info">
            <span class="sharepoint-navigator__item-name">{{ drive.name }}</span>
            <span *ngIf="drive.description" class="sharepoint-navigator__item-desc">{{ drive.description }}</span>
          </div>
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </div>
      </div>
    </ng-container>

    <!-- Vista Files/Folders -->
    <ng-container *ngIf="viewStep === 'files' && !loading">
      <div *ngIf="fileItems.length === 0" class="sharepoint-navigator__empty">
        <ion-icon name="folder-open-outline"></ion-icon>
        <p>{{'SHAREPOINT.EMPTY_DIR_ADVISE' | translate }}</p>
      </div>
      <div *ngIf="fileItems.length > 0" class="sharepoint-navigator__list">
        <div
          *ngFor="let item of fileItems"
          class="sharepoint-navigator__item"
          [class.folder]="isFolder(item)"
          [class.file]="!isFolder(item)"
          [class.selected]="isItemSelected(item.id)"
          (click)="onItemRowClick(item)">
          <div class="sharepoint-navigator__item-icon">
            <ion-icon
              [name]="isFolder(item) ? 'folder-outline' : 'document-outline'">
            </ion-icon>
          </div>
          <div class="sharepoint-navigator__item-info">
            <span class="sharepoint-navigator__item-name">{{ item.name }}</span>
            <span *ngIf="!isFolder(item) && item.size != null" class="sharepoint-navigator__item-size">
              {{ formatFileSize(item.size) }}
            </span>
            <span *ngIf="item.lastModifiedDateTime" class="sharepoint-navigator__item-modified">
              {{'SHAREPOINT.MODIFIED_LABEL' | translate }}{{ formatDate(item.lastModifiedDateTime) }}
            </span>
          </div>
          <div
            class="sharepoint-navigator__item-checkbox"
            (click)="toggleItemSelection(item); $event.stopPropagation()"
            role="checkbox"
            [attr.aria-checked]="isItemSelected(item.id)"
            aria-label="Marcar elemento">
            <ion-icon
              [name]="isItemSelected(item.id) ? 'checkbox' : 'checkbox-outline'">
            </ion-icon>
          </div>
          <ion-icon
            *ngIf="isFolder(item)"
            class="sharepoint-navigator__item-enter"
            name="chevron-forward-outline">
          </ion-icon>
        </div>
      </div>
    </ng-container>

    <!-- Vista Preview: lista de ficheros a importar antes de confirmar -->
    <ng-container *ngIf="viewStep === 'preview'">
      <div class="sharepoint-navigator__preview-header">
        <p class="sharepoint-navigator__preview-title">
          {{'SHAREPOINT.PREVIEW_FILE_TITLE_1' | translate }}{{ allowedFilesCount }}{{'SHAREPOINT.PREVIEW_FILE_TITLE_2' | translate }}{{ filesToImportPreview.length }}{{'SHAREPOINT.PREVIEW_FILE_TITLE_3' | translate }}
        </p>
        <p class="sharepoint-navigator__preview-desc">
          {{'SHAREPOINT.ALLOWED_FILE_EXTENSIONS_MESSAGE'| translate }}
        </p>
      </div>
      <div class="sharepoint-navigator__list sharepoint-navigator__list--preview">
        <div
          *ngFor="let f of filesToImportPreview"
          class="sharepoint-navigator__item sharepoint-navigator__item--file-preview"
          [class.sharepoint-navigator__item--skipped]="f.allowed === false">
          <div class="sharepoint-navigator__item-icon">
            <ion-icon name="document-outline"></ion-icon>
          </div>
          <div class="sharepoint-navigator__item-info">
            <span class="sharepoint-navigator__item-name">{{ f.name }}</span>
            <span *ngIf="f.path" class="sharepoint-navigator__item-path">{{ f.path }}</span>
            <span *ngIf="f.allowed === false" class="sharepoint-navigator__item-badge">{{'SHAREPOINT.EXTENSION_NOT_ALLOWED_MESSAGE' | translate }}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="sharepoint-navigator__footer">
    <div class="sharepoint-navigator__selected-count">
      <!-- <span *ngIf="viewStep === 'files' && selectedItems.size > 0">
        {{ selectedItems.size }} elemento(s) seleccionado(s)
      </span> -->
      <span *ngIf="viewStep === 'preview'">
        {{ allowedFilesCount }}{{'SHAREPOINT.NUM_FILES_IMPORT_LABEL' | translate}}
        <ng-container *ngIf="allowedFilesCount < filesToImportPreview.length">
          ({{ filesToImportPreview.length - allowedFilesCount }} omitidos)
        </ng-container>
      </span>
    </div>
    <div class="sharepoint-navigator__actions">
      <ng-container *ngIf="viewStep !== 'preview'">
        <button class="sharepoint-navigator__button sharepoint-navigator__button--cancel" (click)="cancel()">
          {{'SHAREPOINT.CANCEL' | translate }}
        </button>
        <button
          class="sharepoint-navigator__button sharepoint-navigator__button--add"
          (click)="addSelectedFiles()"
          [disabled]="selectedItems.size === 0">
          {{'SHAREPOINT.ADD_SELECTED' | translate}}
        </button>
      </ng-container>
      <ng-container *ngIf="viewStep === 'preview'">
        <button class="sharepoint-navigator__button sharepoint-navigator__button--cancel" (click)="goBackFromPreview()">
          {{'SHAREPOINT.BACK' | translate}}
        </button>
        <button
          class="sharepoint-navigator__button sharepoint-navigator__button--add"
          (click)="confirmImport()"
          [disabled]="allowedFilesCount === 0">
          {{'SHAREPOINT.IMPORT' | translate }}
        </button>
      </ng-container>
    </div>
  </div>
</div>
